import type { InputProps as AriaInputProps } from "react-aria-components";
import { Input as AriaTextInput } from "react-aria-components";

export default function TextInput(props: AriaInputProps) {
  const { ...rest } = props;

  return <AriaTextInput {...rest} />;
}
